/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-14 14:27:35
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-09-13 14:43:55
 * @name: 工单管理-修改处理方案
 * @Description: 工单管理-修改处理方案
 * @FilePath: \project\src\module\issue\validator\edit.js
 * @Author: desktop
 */
export const validator = [
  {
    key: 'issue_id',
    description: '工单id',
    required: true,
    required_message: '工单id为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'resolve_plan',
    description: '解决措施',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'resolve_way',
    description: '处理方式 1补发配件 2上门 3更换配件',
    required: true,
    required_message: 'resolve_way为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'send_back_way',
    description: '寄回方式 1先补后退 2先退后补',
    required: false,
    match: (e) => {
      return '';
    }
  },
  {
    key: 'need_send_back',
    description: '是否需要寄回：1=》是，0=》否',
    required: true,
    required_message: 'need_send_back为必传项',
    match: (e) => {
      return '';
    }
  },
  {
    key: 'need_pay',
    description: '是否需要费用：0=》否，1=》是，2=》暂不填写',
    required: true,
    required_message: 'need_pay为必传项',
    match: (e) => {
      return '';
    }
  },
]